import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from 'src/guards/auth.guard';
import { PagesComponent } from '../pages.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { WaitlistComponent } from './waitlist.component';
import { WaitlistItemComponent } from './waitlist-item/waitlist-item.component';
import { WaitlistItemMenuComponent } from './waitlist-item-menu/waitlist-item-menu.component';

export const routes: Routes = [
  { path: '', component: PagesComponent, canActivateChild: [AuthGuard], children: [
    { path: '', redirectTo: 'waitlist', pathMatch: 'full' },
    { path: 'waitlist', component: WaitlistComponent }
  ] },
];


@NgModule({
  declarations: [
    WaitlistComponent,
    WaitlistItemComponent,
    WaitlistItemMenuComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class WaitlistModule { }
